module.exports = __webpack_public_path__ + "static/media/Mina-Regular.466d7e48.ttf";